import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[40rem] mx-auto" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "text-sm" }

import { ref, onMounted } from "vue"
  import { IonContent, IonSearchbar, IonList, IonItem, loadingController, IonLabel, IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/vue"
  import { useCompanyStore } from "@/store/company"
  import Menubar from "@/components/menuBar.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPage',
  setup(__props) {

  const companyStore = useCompanyStore()
  const keyword = ref("")
  const selected = ref("")
  const page = ref(1)
  const onSearch = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await companyStore.retrieveAllCompanies(
      {
        keyword: keyword.value,
        columns: "name,slug,logo",
        page: page.value,
        limit: 10,
      },
      "search"
    )
    loading.dismiss()
    if (!selected.value) companyStore.filters.companies = {}
  }

  onMounted(() => {
    companyStore.isNewState = true
    onSearch()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!

  return (_openBlock(), _createBlock(_unref(IonContent), { class: "ion-padding pb-10" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Menubar),
        _createVNode(_unref(IonSearchbar), {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          animated: true,
          placeholder: "Search for company",
          debounce: 1000,
          class: "w-full p-0 custom",
          color: "light",
          onIonChange: onSearch
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyStore).searchResult, (result) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                key: `${result}_id`,
                href: `/company/${result.slug}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_avatar, {
                    slot: "start",
                    style: {
              '--border-radius': '10px',
            }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        alt: result.name,
                        src: result.logo,
                        class: "object-cover h-full w-full"
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_3, _toDisplayString(result.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["href"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonInfiniteScroll), {
          id: "infinite-scroll",
          threshold: "100px",
          disabled: _unref(companyStore).isLast,
          onIonInfinite: _cache[1] || (_cache[1] = 
          () => {
            _unref(companyStore).isNewState = false
            page.value += page.value
            onSearch()
          }
        )
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInfiniteScrollContent), {
              "loading-spinner": "bubbles",
              "loading-text": "Loading more data..."
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})